<template>
    <div class="context-menu" :class="open ? 'context-menu--opened' : 'context-menu--closed'">
        <div v-if="!open" @click="toggleMenu" class="context-menu__closed d-flex justify-content-center align-items-center">
            <b-icon-list class="context-menu__icon--closed" />
        </div>
        <div v-if="open" @click="toggleMenu">
            <div class="d-flex justify-content-end">
                <b-icon-x-circle class="context-menu__icon--opened" />
            </div>
            <div class="context-menu__part context-menu__lang">
                <div class="d-flex align-items-center">
                    <div class="mr-2">
                        {{ $t('INTERACTION_BASE_UI_SELECT_LANGUAGE_LABEL') }}
                    </div>
                    <div class="context-menu__options d-flex align-items-center">
                        <div
                            v-for="language in languages"
                            :key="language.code"
                            class="context-menu__option"
                            :class="activeLang === language.code ? 'context-menu__option--active' : ''"
                            @click="handleChangeLanguage(language.code)"
                        >
                            {{ language.label }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="context-menu__part context-menu__privacy-policy">
                <span class="context-menu__link" @click="handleShowPrivacyPolicy">
                    {{ $t('INTERACTION_BASE_UI_PRIVACY_POLICY_LABEL') }}
                </span>
            </div>
        </div>


    </div>

</template>
<script>
import {  BIconList, BIconXCircle } from 'bootstrap-vue'
import { mapGetters } from 'vuex'

export default {
    name: 'contextMenu',
    components: {
        BIconList,
        BIconXCircle
    },
    props: {
        productType: String
    },
    data() {
        return {
            open: false,
        }
    },
    computed: {
        ...mapGetters([
            'locales',
        ]),
        languages() {
            return this.locales
                .filter(l => !l.hidden)
                .map(locale => ({
                    code: locale.id || locale.code,
                    label: locale.language || locale.label
                }))
        },
        activeLang() {
            return this.$route.query.locale
        }
    },
    methods: {
        toggleMenu() {
            this.open = !this.open
        },
        handleChangeLanguage(lang) {
            this.$emit('change-language', lang)
        },
        handleShowPrivacyPolicy() {
            const route = this.$router.resolve({ name: 'PrivacyPolicyContainer', query: { product: this.productType, locale: this.activeLang } })
            window.open(route.href, '_blank')
        }
    }
}
</script>
<style lang="scss">
.no-wr {
    flex-shrink: 0;
}
.context-menu {
    min-width: 50px;
    padding: 0.25rem 1rem 0.5rem 1rem;
    color: black;
    background-color: rgba(255, 255, 255, .8);
    border: 1px solid $main-font-grey;
    border-top: none;
    border-radius: 0 0 5px 5px;
    @media screen and (min-width: 1200px) {
        margin-right: 80px;
    }
    @media screen and (min-width: 996px) and (max-width: 1199px) {
        margin-right: 50px;
    }
    margin-right: 16px;
    
    &--closed {
        height: 33px;
        width: 50px;
        transition: height 0.1s ease-in-out, width 0.1s ease-in-out;
    }

    &--opened {
        padding-top: 0.5rem;
        height: 120px;
        min-width: 205px;
        transition: height 0.3s ease-in-out, width 0.3s ease-in-out;

        overflow: hidden;
    }
}

.context-menu__link {
    text-decoration: underline;
    &:hover {
        cursor: pointer;
        color: blue;
    }
}

.context-menu__icon--closed {
    height: 1.5rem;
    width: 1.5rem;
    fill: $main-font-grey;
    &:hover {
        cursor: pointer;
    }
}

.context-menu__icon--opened {
    height: 1.5rem;
    width: 1.5rem;
    &:hover {
        cursor: pointer;
    }
    margin-bottom: 0.75rem;
    fill: $main-font-grey;
}

.context-menu__part {
    margin-bottom: 0.7rem;
}

.context-menu__option {  
  border: 1px solid $main-font-grey;
  border-radius: 5px;
  padding: 0.125rem 0.25rem;
  text-align: center;
  margin-right: 0.25rem;
  &:hover {
    cursor: pointer;
    background: $bq-green;
    border-color: $bq-green;
    color: white;
    transition: all 0.2s ease-in-out;
  }

  &--active {
    background: $bq-green;
    border-color: $bq-green;
    color: white;
  }
  
  &.context-menu__option:last-child {
    margin-right: 0;
  }
}

.context-menu__hide-lang-icon {
  margin-left: 9px;
  margin-right: 2px;
}

.context-menu__hide-lang {
  width: 19px;
  height: 19px;
  border-radius: 50%;
  background-color: white;
  &:hover {
    background: rgba(202, 202, 202, 0.7);
    cursor: pointer;
  }
}
</style>